import React from 'react';

export function ActionIcon(): JSX.Element {
  return (
    <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
      <rect fill='#EFF7F6' height='24' rx='6' width='24' />
      <g clipPath='url(#clip0_10119_61918)'>
        <path
          d='M7.16895 7.62702V16.372C7.16893 16.5017 7.20254 16.6291 7.26649 16.742C7.33043 16.8548 7.42254 16.9491 7.5338 17.0156C7.64507 17.0822 7.7717 17.1188 7.90133 17.1219C8.03097 17.1249 8.15917 17.0943 8.27345 17.033L16.4349 12.6605C16.5545 12.5964 16.6544 12.5011 16.7241 12.3847C16.7938 12.2683 16.8306 12.1352 16.8306 11.9995C16.8306 11.8639 16.7938 11.7307 16.7241 11.6143C16.6544 11.4979 16.5545 11.4026 16.4349 11.3385L8.27345 6.96602C8.15917 6.90473 8.03097 6.87411 7.90133 6.87716C7.7717 6.88021 7.64507 6.91681 7.5338 6.9834C7.42254 7.04999 7.33043 7.14428 7.26649 7.25709C7.20254 7.36989 7.16893 7.49735 7.16895 7.62702Z'
          stroke='#36A88A'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_10119_61918'>
          <rect fill='white' height='12' transform='translate(6 6)' width='12' />
        </clipPath>
      </defs>
    </svg>
  );
}
